module.exports = __webpack_public_path__ + "img/thumb-chocolade-cranberry-havermoutkoekjes.8228f5f0.jpg";